module.exports = __webpack_public_path__ + "static/media/group-all-on.337160c7.svg";